import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

export interface IDateRangeControl {
  from: any;
  to: any;
}

@Component({
  selector: 'app-date-range',
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.scss'],
})
export class DateRangeComponent implements OnInit {
  @Input() rangeControl: UntypedFormControl;
  @Input() fromControl: UntypedFormControl;
  @Input() toControl: UntypedFormControl;

  constructor() {}

  ngOnInit(): void {
    if (this.rangeControl) {
      if (!this.rangeControl.value || !this.rangeControl.value.from || !this.rangeControl.value.to) {
        // eslint-disable-next-line no-console
        console.error('rangeControl with type IDateRangeControl must be provided');
      }
    }
    if (!this.fromControl) {
      this.fromControl = new UntypedFormControl();
      if (this.rangeControl?.value?.from) {
        this.fromControl.setValue(this.rangeControl.value.from);
      }
    }
    if (!this.toControl) {
      this.toControl = new UntypedFormControl();
      if (this.rangeControl?.value?.to) {
        this.toControl.setValue(this.rangeControl.value.to);
      }
    }

    this.toControl.valueChanges.subscribe({
      next: (data) => {
        if (this.rangeControl) {
          this.rangeControl.setValue({
            from: this.fromControl.value,
            to: this.toControl.value,
          });
        }
      },
    });
  }

  clear() {
    this.fromControl.setValue(null);
    this.toControl.setValue(null);
  }
}
